import Model from '@/store/model';

class HearingComprehensionTestOption extends Model {
  map(json) {
    super.map(json);

    if (json.alternative_answers && Array.isArray(json.alternative_answers)) {
      this.alternativeAnswers = json.alternative_answers;
    }
  }
}

export default HearingComprehensionTestOption;
